import { render, staticRenderFns } from "./districtsMainView.vue?vue&type=template&id=2d275e20&scoped=true"
import script from "./districtsMainView.vue?vue&type=script&lang=js"
export * from "./districtsMainView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d275e20",
  null
  
)

export default component.exports